"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _customToolTip = _interopRequireDefault(require("../customToolTip"));

require("antd/dist/antd.css");

require("./ButtonComponent.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ButtonComponent = function ButtonComponent(_ref) {
  var type = _ref.type,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      children = _ref.children,
      className = _ref.className,
      loading = _ref.loading,
      htmlType = _ref.htmlType,
      showTooltip = _ref.showTooltip,
      size = _ref.size;

  var button = /*#__PURE__*/_react["default"].createElement(_antd.Button, {
    type: type || "primary",
    disabled: disabled || false,
    onClick: onClick,
    className: className,
    loading: loading,
    htmlType: htmlType || "button",
    size: size
  }, children);

  return showTooltip ? /*#__PURE__*/_react["default"].createElement(_customToolTip["default"], {
    title: children
  }, button) : button;
};

var _default = ButtonComponent;
exports["default"] = _default;